import type { FC } from 'react'
import React from 'react'
import type { FioSuggestion } from '@pole-api/lib-integration-dadata-api/lib/models/FioSuggestion'

const SuggestionFio: FC<FioSuggestion> = ({ value }) => {
  return <span>{value}</span>
}

export default SuggestionFio
